import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

interface Props {
    email: string | undefined;
}

export function SuccessDialog({email}: Props) {
    return (
        <RsnDialog.Window placement='bottom'>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status='check' />}} />
            <RsnDialog.Body>
                <div className='flex flex-col gap-4 text-center'>
                    <div className='fv-heading-m text-neutral-100'>The report is generating</div>
                    <div className='fv-text-l-regular text-neutral-90'>
                        While completed, we’ll send it to your email <span className='whitespace-nowrap'>{email}</span>.
                    </div>
                </div>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent={'secondary'} as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
